"use client";
import { useState, useEffect, createContext, FC } from "react";

export const useDeviceType = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isPad, setIsPad] = useState(false);
  const [windowWidth, setWindowWidth] = useState(0);

  const isWindow = typeof window !== "undefined";

  const getWidth = () => (isWindow ? window.innerWidth : windowWidth);

  const resize = () => setWindowWidth(getWidth());

  useEffect(() => {
    if (isWindow) {
      setWindowWidth(getWidth());

      window.addEventListener("resize", resize);

      return () => window.removeEventListener("resize", resize);
    }
    //eslint-disable-next-line
  }, [isWindow]);

  useEffect(() => {
    setIsMobile(getWidth() < 1000);
    setIsPad(getWidth() < 1000 && getWidth() >= 700);
  }, [windowWidth]);

  return {
    isMobile,
    isPad,
  };
};

export const DeviceTypeContext = createContext({
  isMobile: false,
  isPad: false,
});

export const MobileProvider = ({ children }: { children: React.ReactNode }) => {
  const deviceType = useDeviceType();

  return (
    <DeviceTypeContext.Provider value={deviceType}>
      {children}
    </DeviceTypeContext.Provider>
  );
};

export const WithMobile = <P extends object>(
  WrappedComponent: React.ComponentType<P> | FC<P>
) => {
  const withData: React.FC<P> = (props) => {
    const deviceType = useDeviceType();

    return <WrappedComponent {...props} deviceType={deviceType} />;
  };

  return withData;
};
